import React from 'react'
import FastTagReportFill from './fastTagReportFill/FastTagReportFill'
import FastTagReportList from './fastTagReportsList/FastTagReportList'

function FastTagReports() {
    return (
        <>
            <FastTagReportFill />
            <FastTagReportList />
        </>
    )
}

export default FastTagReports